export class AccordionSection {
    // public static LEARN_MORE = {key: "learn-more", title: "To Learn More..."};
    public static KEY_OBJECTIVE = {key: "key-objective", title: "Key Objectives"};
    public static POPULATION = {key: "population", title: "Population(s) and Equity"};
    public static LOCATION = {key: "location", title: "Location and Community Settings"};
    public static GOALS = {key: "goals", title: "Goals and Evaluation"};
    public static PARTNERS = {key: "partners", title: "Partners and Community Connections"};
    public static FUNDING = {key: "funding", title: "Funding and Staffing"};

}